import store from "../store";

export default async (to, from, next) => {
    
    
    // console.log(store.getters['auth/hasToken'],to)
    localStorage.setItem('fromname',from.name)
    localStorage.setItem('frompath',`${from.path}`)
    localStorage.setItem('toname',to.name)
    localStorage.setItem('topath',`${to.path}`)
    document.title = `${to.name}- Mobe mão Obra`
    if (to.name === 'recuperaSenha' && store.getters['auth/hasToken'] === false) {
        next()
        return false
    }
    if (to.name === 'cadastrar' && store.getters['auth/hasToken'] === false) {
        next()
        return false
    }
    if (to.name === 'login' && store.getters['auth/hasToken'] === false) {
        try {
            await store.dispatch('auth/ActionCheckToken')
            next({name: to.name})
        } catch (error) {
            next()
        }
    }
    if (to.name !== 'login' && store.getters['auth/hasToken'] === true) {
        try {
        
            await store.dispatch('auth/ActionCheckToken')
            next({name:to.name});
        } catch (error) {
            next();
        }
    }
    if (to.name !== 'login' && store.getters['auth/hasToken'] === false){
        next({name:'login'});
    }
    if (to.name === 'login' && store.getters['auth/hasToken'] === true){
        next({name:'home'});
        
    }

    
    next()
}
